import styles from './style.module.css'
import { Link } from 'react-router-dom';
import Moment from 'react-moment';
import 'moment/locale/ru';


const SchoolCard = ({
    title,
    date,
    season,
    managements,
    program,
    is_active,
}
) => {
    return (
        <div className={styles.schools__area}>
            <div className={styles.card + ' ' + (is_active ? styles.active : '')}>
                <div className={styles.col}>
                    <div className={styles.title}>Дата: </div>
                    <div className={styles.content}>
                        <Moment format="DD.MM.YYYY">
                            {date}
                        </Moment>
                    </div>
                </div>
                <div className={styles.col}>
                    <div className={styles.title}>Наименование: </div>
                    <div className={styles.content}>{title}</div>
                </div>
                <div className={styles.col}>
                    <div className={styles.title}>Руководители: </div>
                    <div className={styles.content}>{managements}</div>
                </div>
                <div className={styles.col}>
                    <div className={styles.title}>Сезон: </div>
                    <div className={styles.content}>№{season.season_number}</div>
                </div>
                {program &&
                    <div className={styles.col}>
                        <><div className={styles.title}>Программа: </div>
                            <div className={styles.content}><Link to={program}>Скачать</Link></div>
                        </>
                    </div>
                }
            </div>
        </div>
    );
}

export default SchoolCard;